// extracted by mini-css-extract-plugin
export default {"link":"dD-z","disabled":"eD-z"};